import React from "react";
import { Row, Col, Form, Button, Image } from "react-bootstrap";
const CommentInput = ({
  user_avatar_image_url,
  comment,
  handleKeyDown,
  handleFocus,
  onChangeComment,
  onComment,
  prefix,
}) => {
  return (
    <Row className={prefix("comment-content")}>
      <Col xs={1} className="p-0 border">
        <Image
          roundedCircle
          fluid
          // className={prefix("user-avatar")}
          src={user_avatar_image_url}
          alt={""}
        />
      </Col>
      <Col xs={11}>
        <Form className={prefix("comment-form")} onSubmit={onComment}>
          <Form.Row>
            <Col xs={10}>
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                  style={{
                    height: "41px",
                    overflow: "hidden",
                    resize: "none",
                  }}
                  maxLength={500}
                  as="textarea"
                  rows={1}
                  onChange={onChangeComment}
                  value={comment}
                  name="comment"
                  placeholder="Add a public comment (max. 500 characters)..."
                  onKeyDown={handleKeyDown}
                  onFocus={handleFocus}
                />
              </Form.Group>
            </Col>

            <Col xs={2}>
              <Button
                className="modal_button"
                style={{ marginLeft: "20px", marginTop: "-5px" }}
                type="submit"
                disabled={!comment}
              >
                Submit
              </Button>
            </Col>
          </Form.Row>
        </Form>
      </Col>
    </Row>
  );
};

export default CommentInput;
